// extracted by mini-css-extract-plugin
module.exports = {"simpleLayout":"Layout_simpleLayout__ECjIb","simpleForm":"Layout_simpleForm__MBLX0"};